export interface PriceTupleT {
  real: number;
  promoted: number;
}

export interface PricesV3T {
  monthly?: PriceTupleT;
  yearly?: PriceTupleT;
}

export interface PromotionV3T {
  beforePromoText?: string;
  afterPromoText?: string;
  promotionalCode?: string;
}

/**
 * Traits whose capital is added together to compute the chip "totalCapital".
 * DISABILITY is excluded by product decision: it covers the same person and
 * its capital overlaps with DEATH, so summing it would double-count.
 */
export const CAPITAL_TRAITS_FOR_TOTAL = ["DEATH", "SERIOUS_ILLNESS"] as const;
